if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function (search, replacement) {
    if (search instanceof RegExp) {
      throw new TypeError('String.prototype.replaceAll doesn’t accept RegExp');
    }
    return this.split(search).join(replacement);
  };
}
